import CommonEvents from '../../../../common/constants/events';
import EventContainer from '../../../../common/event/EventContainer';
import { IUserData } from '../../../../common/model/IUser';
import logger from '../../common/service/logger';
import { ICarDetails } from '../../../../common/model/ICarDetails';

interface ISaveOfferPayload {
  configuration: ICarDetails;
  email: string;
}

export const offer = {
  externalSave: (eventContainer: EventContainer, carConfiguration: ICarDetails, userData: null | IUserData) => {
    let saveOfferPayload: ISaveOfferPayload = {
      configuration: carConfiguration,
      email: '',
    };

    if (userData) {
      saveOfferPayload = { ...saveOfferPayload, email: userData.email };
    }

    logger.info(`Emitted: ${CommonEvents.SAVE_OFFER} with:`);
    logger.info(saveOfferPayload);

    eventContainer.emit(CommonEvents.SAVE_OFFER, saveOfferPayload);
  },
};
